import routes from '@modules/sheet-event/sheet-event-routes';
import store from '@modules/sheet-event/sheet-event-store';

export default {
  routes,
  store,
};
